export const NAVBAR_HEIGHT = 60;
export const SEEK_TIME_OFFSET = 100;
export const EDITOR_DRAWER_WIDTH = 350;
export const FILE_SERVICE_APIS = [
  'files.api.demostack.com',
  'files.dev.demostack.com',
  'files.staging.demostack.com',
];

export const CAPTURE_IFRAME_ID = 'recorder-iframe';

export const SCREENSHOT_CONTAINER_THRESHOLD_DELTA = 1.05;
